import { Settings } from './sample/Welcome';

export const getHomeUrl = (settings: Settings) => {
  return window.location.host.indexOf('localhost') > -1
    ? 'https://localhost:3002'
    : settings.HomeUrl;
};
